<template>
  <div class="animated fadeIn">
    <!--
    <b-row>
         <b-col class="card text-center">
             <h3 class="text-info p-5" style="font-weight: bold">PROGRAMA AUTOMATIZADO DE CONTABILIDAD</h3>
         </b-col>
     </b-row>
     -->

    <b-row>
      <b-col cols="12" xs="12" sm="12" md="6">
        <b-card>
          <p class="text-secondary negrita">Pendientes de Aprobación:</p>
          <b-row>
          <b-col cols="12" xs="12" sm="12" md="6">
            <b-card :no-body="true" footer-class="px-3 py-2">
              <b-card-body class="p-3 clearfix"
              >
                <b-link to="/cheques-transferencias">
                <i class="icon-wallet bg-primary p-3 font-2xl mr-3 float-left"></i>
                </b-link>
                <b-link to="/cheques-transferencias">
                  <div
                    class="h2 text-primary mb-0 mt-2"
                    v-b-tooltip.hover
                    title="Cheques / Transferencias Pendientes"
                  >{{ cheques_pendientes }}
                  </div>
                </b-link>
                <div class="text-muted font-weight-bold font-xs">Cheques / Transf.</div>
              </b-card-body>
              <div slot="footer">
                <b-link class="font-weight-bold font-xs btn-block text-muted" to="/cheques-transferencias">Ver <i
                  class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col>

          <b-col cols="12" xs="12" sm="12" md="6">
            <b-card :no-body="true" footer-class="px-3 py-2">
              <b-card-body class="p-3 clearfix">
                <b-link to="/comprobantes-diario">
                <i class="fa fa-edit bg-primary p-3 font-2xl mr-3 float-left"></i>
                </b-link>
                <b-link to="/comprobantes-diario">
                <div
                  class="h2 text-primary mb-0 mt-2"
                  v-b-tooltip.hover
                  title="Comprobantes Pendientes"
                >{{ comprobantes_pendientes }}
                </div>
                </b-link>
                <div class="text-muted font-weight-bold font-xs">Comprobantes</div>
              </b-card-body>
              <div slot="footer">
                <b-link class="font-weight-bold font-xs btn-block text-muted" to="/comprobantes-diario">Ver <i
                  class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col>

          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" class="text-center" >
        <b-card style="max-height:232px; overflow:hidden">
          <img
            class="navbar-brand-minimized"
            src="/img/paco.jpeg"
            style="max-height:232px; max-width: 390px"
            alt="paco"
          />
        </b-card>
      </b-col>
    </b-row>
     <b-row class="animated fadeIn">
      <b-col cols="12" class="text-center" >
      <div style="width:100%;">

      <grafico-utilidad :empresa_id="empresaId" />

      </div>
      </b-col>
      </b-row>







  </div>
</template>

<script>
import {mapGetters} from "vuex";
import GraficoUtilidad from "@/components/charts/GraficoUtilidadPerdidaBar.vue";

export default {
  name: 'dashboard',
  components:{
    GraficoUtilidad
  },

  data() {
    return {
      comprobantes_pendientes: 0,
      cheques_pendientes: 0,
    }
  },
  computed: {
    ...mapGetters("authentication", ["empresaId"]),
  },
  methods: {
    async loadData() {
      try {
        // eslint-disable-next-line no-undef
        const {data, status} = await axios.post('/api/reportes/dashboard', {empresa_id: this.empresaId});
        if (status == 200) {
          if (data && data.pendientes) {
            let {pendientes} = data;
            let comprobantes = pendientes.filter(item => item.id == 1);
            let cheques = pendientes.filter(item => item.id == 2);
            this.comprobantes_pendientes = comprobantes[0].cantidad;
            this.cheques_pendientes = cheques[0].cantidad;
          }


        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  mounted() {
    this.loadData()
  },

}
</script>

